import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { screenTitle } from 'utils/UrlListener';
import getCanonicalUrl from 'utils/canonicalUrl';

import IncludeOnPlatforms from '../hoc/IncludeOnPlatforms';
import { Translator } from 'Translator';
import { RouteComponentProps, withRouter } from 'react-router-dom';

const availableLanguages = require('resources/languages.json');

class DefaultHead extends PureComponent<RouteComponentProps> {
  render() {
    const { location } = this.props;
    const path = location.pathname.split('/');
    if (path.length > 1 && availableLanguages.indexOf(path[1]) > -1) {
      path.splice(1, 1);
    }
    const noindex = ENVIRONMENT !== "production" || path.includes('l') || // no index on all /l/ pages
      path.includes('s'); // no index on all /s/ pages

    const langCode = Translator.getLanguageCode();
    const title = screenTitle();
    return (
      <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={getCanonicalUrl(window.location.protocol, window.location.pathname)}/>
        {availableLanguages.map((locale) => {
          const url = `${window.location.protocol}//www.withlocals.com${((locale === 'en') ? '' : '/' + locale)}${path.join('/')}`;
          return <link key={locale} rel="alternate" href={url} hrefLang={locale}/>;
        })}
        <html lang={langCode}/>
        {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow" />}
      </Helmet>
    );
  }
}

export default IncludeOnPlatforms(['pizza'])(withRouter(DefaultHead));
